import React from 'react';
import './StorySectionAlt.css';

export default function StorySectionAlt() {
  return (
    <section className="section story-alt-section" id="story-2">
      <div className="story-alt-split">
        <div className="story-alt-pane">
          <div className="container">
            <div className="story-alt-content">
              <h3 className="story-alt-kicker">Ice Cream</h3>
              <div className="story-alt-est">HERE'S THE SCOOP</div>
              <p className="story-alt-text">
                Our ice cream truck, brimming with an assortment of frozen delights, is ready to roll up to your
                charity or service event. Simply sign up below, complete the waiver, and grant us a prime parking
                spot for our truck to kick off the cool celebration.
              </p>
            </div>
          </div>
        </div>
        <div className="story-alt-media" aria-hidden="true" />
      </div>
    </section>
  );
}
